import { Counter, CounterProps } from "PFApp/components/counter/counter";
import { CustomValueImportRowsMeta } from "PFCore/services/admin/imports/fetch_custom_value_import_rows";

import css from "./import_data_table_page.module.scss";

export type ImportDataTableCountersProps = {
  selectedCounter: string;
  onCounterChange: (counter: string) => void;
  meta?: CustomValueImportRowsMeta;
  counters: Pick<CounterProps, "counter" | "selected" | "code" | "title">[];
};

export const ImportDataTableCounters = ({ onCounterChange, counters }: ImportDataTableCountersProps) => (
  <div className={css.counters}>
    {counters.map((counter) => (
      <Counter
        {...counter}
        onClick={() => onCounterChange(counter.code)}
        key={counter.code}
        classes={{ button: css.button }}
      />
    ))}
  </div>
);
